
import {
    TouchableOpacity,
    Image,
    View
} from "react-native";
import {
    type NewsCardProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    CalendarIcon
} from "lucide-react-native";

const NewsCard = ({
    coverPhotoURL,
    shortContent,
    createdAt,
    onPress,
    title,
    type
}: NewsCardProps) => {
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TouchableOpacity
        onPress={onPress}
        style={[
            stylesheet.container,
            {
                marginBottom: spaces.spacingMd
            }
        ]}
    >
        <View
            style={[
                stylesheet.imageContainer,
                {
                    marginRight: spaces.spacingMd,
                    borderRadius: radiuses.sm
                }
            ]}
        >
            <Image
                source={{
                    uri: coverPhotoURL
                }}
                resizeMode="cover"
                style={[
                    stylesheet.image,
                    {
                        borderRadius: radiuses.sm
                    }
                ]}
            />
        </View>
        <View
            style={[
                stylesheet.contentContainer
            ]}
        >
            <Text
                variant="bodyMediumSize"
                color="mid"
            >
                {type}
            </Text>
            <Text
                variant="titleMediumSize"
                color="high"
                style={[
                    stylesheet.title,
                    {
                        marginBottom: spaces.spacingXs
                    }
                ]}
            >
                {title}
            </Text>
            <Text
                variant="bodySmallSize"
                color="low"
                style={[
                    stylesheet.title,
                    {
                        marginBottom: spaces.spacingSm
                    }
                ]}
            >
                {shortContent}
            </Text>
            <View
                style={stylesheet.footerContainer}
            >
                <CalendarIcon
                    color={colors.content.icon.mid}
                    style={[
                        {
                            marginRight: spaces.spacingSm
                        }
                    ]}
                    size={14}
                />
                <Text
                    variant="bodyMediumSize"
                    color="mid"
                >
                    {createdAt}
                </Text>
            </View>
        </View>
    </TouchableOpacity>;
};
export default NewsCard;
